import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";


interface HeroIAdvizeProps {
  totalInscriptions: number;
  showCounter?: boolean;
}

const HeroIAdvize = ({ totalInscriptions, showCounter = true }: HeroIAdvizeProps) => {
  return (
    <section className="relative min-h-[50vh] flex items-center justify-center px-4 py-12 overflow-hidden">
      {/* Gradient Background */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          background: 'var(--gradient-hero)',
        }}
      />
      
      {/* Animated Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 z-0">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(45deg, hsl(221 62% 35%) 1px, transparent 1px),
            linear-gradient(-45deg, hsl(221 62% 35%) 1px, transparent 1px)
          `,
          backgroundSize: '30px 30px',
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center space-y-4">
        <div className="space-y-2">
          <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight animate-fade-in">
            iAdvize
            <span className="block text-3xl md:text-5xl mt-2">Action collective des conseillers Ibbü</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-medium animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Anciens conseillers de la plateforme iAdvize, faisons valoir nos droits ensemble
          </p>
        </div>

        <p className="text-base md:text-lg text-white/70 font-light animate-fade-in" style={{ animationDelay: '0.15s' }}>
          Informez-vous, témoignez et rejoignez notre démarche collective.
        </p>

        <div className="pt-2 animate-fade-in" style={{ animationDelay: '0.15s' }}>
          <Link to="/inscription">
            <Button 
              size="lg"
              className="bg-red-600 text-white hover:bg-red-700 shadow-2xl hover:shadow-red-500/50 transition-all duration-300 text-xl px-12 py-8 rounded-full font-semibold"
            >
              Rejoindre l'action collective
            </Button>
          </Link>
        </div>

        {/* Counter */}
        {showCounter && (
          <div className="pt-4 flex justify-center animate-fade-in" style={{ animationDelay: '0.15s' }}>
            <div
              className="group relative inline-flex items-center gap-5 px-8 py-5 rounded-2xl backdrop-blur-xl border border-white/25 transition-all duration-500 hover:scale-105 hover:border-white/40"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.06) 100%)',
                boxShadow: '0 20px 60px -15px rgba(0,0,0,0.4), inset 0 1px 0 0 rgba(255,255,255,0.25)',
              }}
            >
              <div className="absolute -inset-px rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{ background: 'linear-gradient(135deg, rgba(239,68,68,0.25), transparent 60%)' }}
              />
              <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-red-500 to-red-700 shadow-lg shadow-red-900/40 ring-2 ring-white/30">
                <Users className="w-7 h-7 text-white" strokeWidth={2.5} />
                <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-green-400 ring-2 ring-white/80 animate-pulse" />
              </div>
              <div className="relative text-left">
                <p className="text-5xl md:text-6xl font-extrabold text-white tracking-tight leading-none tabular-nums drop-shadow-lg">
                  {totalInscriptions}
                </p>
                <p className="mt-1.5 text-sm font-medium text-white/85 uppercase tracking-wider">
                  {totalInscriptions > 1 ? 'conseillers inscrits' : 'conseiller inscrit'}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroIAdvize;
